import { settings } from '@/main/config/settings'
import PathConstants from '@/main/routes/paths'

export const makeSkillWebLoginUrl = (): string => `${settings.SKILLWEB_HOST}/login`

export const makeSkillWebAuthorizeRedirectUrl = (
  redirectTo: string = window.location.href
): string => `${makeSkillWebLoginUrl()}?redirect_uri=${encodeURIComponent(redirectTo)}`

export const makeSkillWebHomeRedirectUrl = (): string => `${settings.SKILLWEB_HOST}/app/courses/`

export const makeSkillWebContentPageRedirectUrl = (contentId: number): string =>
  `${makeSkillWebHomeRedirectUrl()}${contentId}`

export const makeSkillWebMyProfileRedirectUrl = (tab?: string): string =>
  tab ? `${settings.SKILLWEB_HOST}/profile?pageActive=${tab}` : `${settings.SKILLWEB_HOST}/profile`

export const makeSkillWebMyProfileRefundsRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/profile/refunds`

export const makeSkillWebManagerTeamRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/app/authorizations`

export const makeSkillWebManagerUsersRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/app/users`

export const makeSkillWebManagerUserProfileRedirectUrl = (userId: string): string =>
  `${settings.SKILLWEB_HOST}/app/users/${userId}`

export const makeSkillWebRequestsRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/app/requests`

export const makeSkillWebCompaniesRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/app/companies`

export const makeSkillWebCompanyRedirectUrl = (companyId: string): string =>
  `${settings.SKILLWEB_HOST}/app/companies/${companyId}`

export const makeSkillWebInstitutionsRedirectUrl = (): string =>
  `${settings.SKILLWEB_HOST}/app/institutions`

export const makeSkillWebLogoutRedirectUrl = (): string => `${settings.SKILLWEB_HOST}/logout`

export const makeSupportRedirectUrl = (): string => settings.SUPPORT_URL

export const makeCbUnicoSuccessRedirectUrl = (route: PathConstants.RouteProps): string =>
  `${window.location.origin}${route.value}`

export const makeOnboardingRedirectUrl = (route: PathConstants.RouteProps): string =>
  `${window.location.origin}${route.value}?redirect=${encodeURIComponent(window.location.href)}`
